import { Component, OnInit, OnDestroy } from '@angular/core';
import { CourseService } from '../../shared/services/course.service';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';
import { Subscription } from 'rxjs';

interface AssessmentData {
  assessment_id: number;
  threedigitScore: number;
  name: string;
  date: string;
}

interface ScoreStatsResponse {
  status: boolean;
  assessment: AssessmentData[];
  predictedScore: number;
  passingLikelihood: number;
  scoreRanges: number[];
  feedback: string;
}

@Component({
  selector: 'app-score-predictor',
  templateUrl: './score-predictor.component.html',
  styleUrls: ['./score-predictor.component.scss']
})
export class ScorePredictorComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  
  // Loading states
  loading = false;
  
  // Course dropdown data
  subscribedCourses: any[] = [];
  selectedCourse: any;
  courseTitle: string = '';
  // Score prediction data
  predictedScore: number = 0;
  passingLikelihood: number = 0;
  scoreRanges: number[] = [0, 0];
  assessmentData: AssessmentData[] = [];
  feedback: string = '';
  currentDate = new Date();

  courses: any = [];
  // UI states
  isResultsExpanded = true;

  constructor(
    private courseService: CourseService,
    private errorHandler: ErrorHandlerService
  ) { }

  ngOnInit(): void {
    this.courses = JSON.parse(localStorage.getItem('subscriptions'))

    console.log(this.courses)
    if (this.courses.length > 0) {
      this.selectedCourse = this.courses[0].courseID
      this.courseTitle = this.courses[0].courseName
    }
    this.loadScoreStats()
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


  handleCourseChange(courseId: any): void {
    this.selectedCourse = courseId;
    this.loadScoreStats();
  }

  async filterByCourse() {

    this.courseTitle = this.courses.find(course => course.courseID === this.selectedCourse)?.courseName || '';
    
    this.loadScoreStats()
  }

  private loadScoreStats(): void {
    if (!this.selectedCourse) return;
    
    this.loading = true;
    const subscription = this.courseService.getSelfAssessmentScoreStats({
      userId: parseInt(localStorage.getItem('Id') || '0'),
      courseId: this.selectedCourse
    }).subscribe({
      next: (res: any) => {
        if (res?.data) {
          this.updateScoreData(res.data);
        }
        this.loading = false;
      },
      error: (error) => {
        this.errorHandler.handleError(error);
        this.loading = false;
      }
    });
    this.subscriptions.push(subscription);
  }

  private updateScoreData(data: ScoreStatsResponse): void {
    console.log('100',data)
    this.predictedScore = data.predictedScore || 0;
    this.passingLikelihood = data.passingLikelihood ;
    this.scoreRanges = data.scoreRanges || [0, 0];
    this.assessmentData = data.assessment || [];
    this.feedback = data.feedback || '';
  }

  toggleResultsSection(): void {
    this.isResultsExpanded = !this.isResultsExpanded;
  }

  formatDate(dateString: string): string {
    if (!dateString) return '-';
    
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      });
    } catch (error) {
      return '-';
    }
  }
}
